var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-bar'),_c('app-drawer'),_c('v-main',{staticClass:"background-color"},[_c('v-row',[_c('v-col',{staticClass:"col-xl-10 offset-xl-1 pb-0"},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }